export default __webpack_public_path__ + "static/media/divulgação_profono_acesso.700770cb.png";